<template>
  <keep-alive>
    <router-view :key="$route.fullPath"></router-view>
  </keep-alive>
</template>

<script>
	export default {
		name: "admin-display-display-wrapper",
	};
</script>

<style scoped>
</style>
